import { render, staticRenderFns } from "./RCallout.vue?vue&type=template&id=d8621d8a&scoped=true&"
import script from "./RCallout.vue?vue&type=script&lang=js&"
export * from "./RCallout.vue?vue&type=script&lang=js&"
import style0 from "./RCallout.vue?vue&type=style&index=0&id=d8621d8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8621d8a",
  null
  
)

export default component.exports